<template>
	<div class="divider-content">
		<h1>Svi naši proizvodi su ručno pravljeni u malim serijama sa puno pažnje i ljubavi</h1>
		<p>Sve dok ne probate naše proizvode, ne mogu Vam dočarati o čemu je reč</p>
	</div>
</template>

<script>
export default {
	name: "HomeDividerText"
}
</script>

<style scoped>
	* {
		background: #F0EAD6;
	}

	.divider-content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 100px;
		margin-bottom: 100px;
		width: 100%;
		text-align: center;
	}

	h1 {
		font-size: 31px;
		font-weight: bold;
		color: #1A1A1A;
	}

	p {
		font-size: 18px;
		color: #1A1A1A;
	}

    @media only screen and (max-width: 600px) {
        .divider-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-left: 0;
            margin-top: 100px;
            margin-bottom: 100px;
            width: 100%;
            text-align: center;
        }

        h1 {
            font-size: 22px;
        }

        p {
            font-size: 16px;
        }
    }

</style>